import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import BaseModel from "../models/BaseModel";
import BaseModelReference from "../models/BaseModelReference";
import { CableType } from "../models/CableType";
import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";
import { sortArrayByProperty } from "../models/utils";
import { itx } from "../translationItx/itx";
import { isUiModeDeveloper } from "../uiMode";

export default class CableTypeTreeViewModel extends TreeViewModel {
  get typedObj(): CableType {
    return this.obj as CableType;
  }

  get isFolder(): boolean {
    if (isUiModeDeveloper()) {
      return true;
    } else {
      return false;
    }
  }

  getTagNeeded(): boolean {
    if (isUiModeDeveloper()) {
      return true;
    }
    return false;
  }

  getDisableEdit(): boolean {
    return false;
  }
  allowDrag(): boolean {
    return true;
  }
  allowDrop(event: any): boolean {
    return true;
  }
  // informationText(): string {
  //   return itx(
  //     "cableTypeTreeViewModel.defaultType",
  //     "Dies ist der Standard Kabeltyp, welcher bei neuen Verbrauchern automatisch zugewiesen wird.",
  //   );
  // }
  getTitlePostfix(): string | JSX.Element {
    const channelType = this.typedObj as CableType;

    // if (channelType.isDefault) {
    //   return super.inlineButton_Information();
    // }
    return "";
  }

  get childCollection(): Array<BaseModel> | undefined {
    let children = new Array<BaseModel>();

    let partners = new Array<BaseModel>();

    this.typedObj.consumerUsages.forEach((consumer) => {
      partners.push(consumer);
    });

    partners = sortArrayByProperty(partners, "fullTag");

    partners.forEach((partner) => {
      const ref = new BaseModelReference({ referencedObject: partner }, this.typedObj);
      ref.usefromRefencedTreeviewObject = {
        titlePostfix: true,
        fullTitle: false,
        icon: true,
      };

      if (partner) {
        children.push(ref);
      }
    });

    return children;
  }
  // getPropertyControl(setPinned: (pinned: boolean) => void): any {
  //   return <CableTypeProperyView obj={this.obj} setPinned={setPinned} />;
  // }

  get iconUrl(): string | undefined {
    if (this.typedObj) {
      return "lab la-codepen";
    }

    return undefined;
  }
  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Open("homePane.openCableTypeSetting")]; // no itx
  }
  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    return await this.typedObj.handleDrop2(mode, obj);
  }
}
